import { TouchEnd, TouchMove } from 'front-end-core/services/WindowService'
import { BROWSER_MOBILE } from 'front-end-core/constants/browser'
import { pushState } from 'front-end-core/core/history'
import { getTouchEventCoordinates, getLink } from 'front-end-core/helpers/document'
import { NEVER } from 'rxjs'
import { takeUntil, filter, first, catchError, map } from 'rxjs/operators'

const { abs, max } = Math

export const touchClick = function (fn) {
  let onClick, onTouchStart
  if (!BROWSER_MOBILE) {
    onClick = fn
    onTouchStart = e => e.preventDefault()
  } else {
    onClick = e => e.preventDefault()
    onTouchStart = e => {
      const { x, y } = getTouchEventCoordinates(e)
      TouchEnd.pipe(
        takeUntil(TouchMove.skip(5)),
        first(),
        filter(e => {
          const c = getTouchEventCoordinates(e)
          return max(abs(c.x - x), abs(c.y - y)) < 5
        }),
        catchError(() => NEVER),
        map(fn)
      )
    }
  }

  return { onClick, onTouchStart }
}

export const touchLink = touchClick(evt => {
  const target = getLink(evt.target)
  const url = target.href
  pushState.next(url)
})
